import {FBFieldBaseOptions} from "./FBFieldBase.options";

export class FBFieldWithPriceBaseOptions extends FBFieldBaseOptions{
    public PriceType:PriceTypeEnum;
    public Price:string;
    public SalePrice:string;
    public HidePrice:boolean;
    public ShowQuantitySelector:boolean;
    public QuantityPosition:'left'|'right'|'top'|'bottom';
    public QuantityMinimumValue=0;
    public QuantityMaximumValue=0;
    public QuantityDefaultValue='';
    public QuantityPlaceholder='';
    public QuantityLabel='';



    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.PriceType=PriceTypeEnum.none;
        this.Price='';
        this.SalePrice= '';
        this.HidePrice=true;

        this.ShowQuantitySelector=false;
        this.QuantityPosition='bottom';
        this.QuantityMaximumValue=0;
        this.QuantityMinimumValue=0;
        this.QuantityDefaultValue='';
        this.QuantityPlaceholder='';
        this.QuantityLabel='Quantity';
    }
}


export enum PriceTypeEnum{
    fixed_amount='fixed_amount',
    quantity='quantity',
    current_value='current_value',
    percent_of_original_price='percent_of_original_price',
    percent_or_original_price_plus_options='percent_or_original_price_plus_options',
    price_per_word='price_per_word',
    price_per_char='price_per_char',
    none='none',
    options='options',
    price_per_item='price_per_item',
    sum_of_fields_in_group='sum_of_fields_in_group',
    price_per_day='price_per_day',
    formula='formula'
}